import {
  getCollectionOptionsForSelect,
  getFieldOptionsForAddToRemoveFromSelect,
  getFieldOptionsForCollectionSelect,
} from '../pluginComponentApi';

export default async function (editor, opt = {}) {
  const { collections, bindCollectionOptions } = opt;
  const traitManager = editor.TraitManager;
  const { session, collection } = bindCollectionOptions;
  let componentContent = '';
  const style = document.createElement('style');
  style.innerHTML = `
        .checkmark::after {
            left: 4px;
            top: 4px;
        }
        checkbox{
        all:unset;
        }
       
        select option:first-child {
            color: grey;
        }
        select.empty {
            color: grey;
        }
        select option[disabled]:first-child {
            display: none;
        }
        input[type=webconnect-text] {
            display:block;
        }
        
  `;
  document.head.appendChild(style);
  if (collection || session) {
    traitManager.addType('addTo-removeFrom-form-element-trait', {
      createInput({ trait }) {
        const customLabel = trait.attributes.customLabel;
        componentContent = trait.attributes.content;
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `
    <div id="AddToRemoveFromCollection">
    ${
      collection || session || collections
        ? `
        <div class="gjs-container">
          <div class="gjs-row">
            <div id="select-getTextFrom-div" class="gjs-field-wrp gjs-field-wrp--select-getTextFrom">
            <div class="gjs-field">
              <select class="select-getTextFrom form-control form-control-sm options-light">
                <option value="" selected>- Get Content -</option>
                ${
                  session
                    ? `
                    <option value="session">${customLabel} Logged In User</option>
                          `
                    : ''
                }
                ${
                  collections
                    ? `
                    <option value="collections">${customLabel} Collections</option>
                          `
                    : ''
                }
              </select>
              </div>
            </div>
          </div>
        </div>
        `
        : ''
    }
        <div class="form-group">
          <div class="row">
            <div id="select-parent-collection-div" class="col-md" style="display: none">
                    <select class="selectParentCollection form-control form-control-sm options-light">

                    </select>
            </div>
            <div id="select-parent-collection-field-div" class="col-md" style="display: none">
                    <select class="selectParentCollectionField form-control form-control-sm options-light">

                    </select>
            </div>
            <div id="select-field-div" class="col-md" style="display: none">
                    <select class="selectField form-control form-control-sm options-light">

                    </select>
            </div>
            <div id="select-url-field-div" class="col-md" style="display: none">
                    <select class="selectURLField form-control form-control-sm options-light">

                    </select>
            </div>
          </div>
        </div>
    </div>
    `;
        const selectGetTextFrom = el.querySelector('.select-getTextFrom');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const selectField = el.querySelector('.selectField');
        const selectParentCollectionDiv = el.querySelector('#select-parent-collection-div');
        const selectParentCollection = el.querySelector('.selectParentCollection');

        selectGetTextFrom.addEventListener('change', async (ev) => {
          selectField.innerHTML = '';
          selectParentCollection.innerHTML = '';
          let optionHtml = `<option value="" selected>None</option>`;
          selectFieldDiv.style.display = 'block';
          if (selectGetTextFrom.value === 'session') {
            optionHtml += `${session.options
              .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
              .join('')}`;
            selectField.innerHTML = optionHtml;
          } else if (selectGetTextFrom.value === 'collections') {
            selectParentCollectionDiv.style.display = 'block';
            selectFieldDiv.style.display = 'none';
            optionHtml = collections ? getCollectionOptionsForSelect(collections) : '';
            selectParentCollection.innerHTML = optionHtml;
          } else {
            optionHtml = collection
              ? getFieldOptionsForAddToRemoveFromSelect(collection.options)
              : '';
            selectField.innerHTML = optionHtml;
          }
        });

        return el;
      },
      onEvent({ elInput, component }) {
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const select = elInput.querySelector('.selectField');
        const selectGetTextFrom = document.querySelector('.select-getTextFrom');
        const selectGetTextFromValue = selectGetTextFrom.value;
        const selectFieldValue = select.value;

        const selectParentCollectionDiv = elInput.querySelector('#select-parent-collection-div');
        const selectParentCollection = elInput.querySelector('.selectParentCollection');
        const selectParentCollectionFieldDiv = elInput.querySelector(
          '#select-parent-collection-field-div',
        );
        const selectParentCollectionField = elInput.querySelector('.selectParentCollectionField');

        let selectParentCollectionValue = selectParentCollection.value;
        let selectParentCollectionFieldValue = selectParentCollectionField.value;

        let attr = component.getAttributes();

        attr['data-select-get-text-from'] = selectGetTextFromValue
          ? selectGetTextFromValue
          : 'collection';
        component.addAttributes(attr);

        if (selectGetTextFromValue) {
          if (selectGetTextFromValue === 'session' || selectGetTextFromValue === 'collection') {
            selectParentCollection.innerHTML = '';
            selectParentCollectionField.innerHTML = '';
            selectParentCollectionDiv.style.display = 'none';
            selectParentCollectionFieldDiv.style.display = 'none';
          }

          selectParentCollection.addEventListener('change', async (ev) => {
            selectParentCollectionField.innerHTML = '';
            selectParentCollectionFieldDiv.style.display = 'block';

            let optionHtml = `<option value="" selected>None</option>`;
            selectParentCollectionValue = selectParentCollection.value;

            if (selectParentCollectionValue) {
              attr['data-form-parent-collection'] = selectParentCollectionValue;
              attr['action'] = `collection-form/${selectParentCollectionValue}/items`;
              component.addAttributes(attr);
              let selectedParentCollection = collections.filter(
                (e) => e.collectionName === selectParentCollectionValue,
              );

              optionHtml = selectedParentCollection[0].fields
                ? getFieldOptionsForCollectionSelect(selectedParentCollection[0].fields)
                : '';

              selectParentCollectionField.innerHTML = optionHtml;
            } else {
              delete attr['data-form-parent-collection'];
            }
          });

          selectParentCollectionField.addEventListener('change', async (ev) => {
            selectParentCollectionFieldDiv.style.display = 'block';

            selectParentCollectionFieldValue = selectParentCollectionField
              ? selectParentCollectionField.value
              : '';
            let addRemoveCollectionFrom = attr['collectionFrom'];
            if (selectParentCollectionFieldValue) {
              let fieldValueId = selectParentCollectionFieldValue.split('#');
              let id = fieldValueId[0];
              let value = fieldValueId[1];
              let formCollection =
                addRemoveCollectionFrom === 'getFromPageContext'
                  ? collection.collectionId
                  : fieldValueId[2];

              attr['data-form-element-collection'] = value;
              attr['data-form-element-collection-id'] = id;
              attr['data-form-collection'] = formCollection;
              component.addAttributes(attr);
            } else {
              delete attr['data-form-element-collection'];
              delete attr['data-form-element-collection-id'];
              delete attr['data-form-collection'];
            }
          });

          const sessionFieldValue = attr['data-form-element-session'] || '';
          const collectionFieldValue = attr['data-form-element-collection'] || '';

          if (selectFieldValue) {
            const id = attr.id;
            attr = {};
            attr.id = id;
            component.addAttributes(attr);

            delete attr['data-form-element-data-group'];

            if (selectGetTextFromValue && selectGetTextFromValue === 'session') {
              selectParentCollection.innerHTML = '';
              selectParentCollectionField.innerHTML = '';
              selectParentCollectionDiv.style.display = 'none';
              selectParentCollectionFieldDiv.style.display = 'none';

              attr['data-form-element-session'] = selectFieldValue;
              delete attr['data-form-element-collection'];
            } else if (selectGetTextFromValue && selectGetTextFromValue === 'collection') {
              selectParentCollection.innerHTML = '';
              selectParentCollectionField.innerHTML = '';
              selectParentCollectionDiv.style.display = 'none';
              selectParentCollectionFieldDiv.style.display = 'none';

              let fieldValueId = selectFieldValue.split('#');
              let id = fieldValueId[0];
              let value = fieldValueId[1];

              attr['data-form-element-collection'] = value;
              attr['data-form-element-collection-id'] = id;
              attr['data-form-parent-collection'] = collection.collectionId;
              delete attr['data-form-element-session'];
            } else if (selectGetTextFromValue && selectGetTextFromValue === 'collections') {
              attr['data-form-parent-collection'] = selectFieldValue;
              delete attr['data-form-element-session'];
            }
            component.set('content', '');
            component.addAttributes(attr);
          } else {
            component.addAttributes(attr);
            component.set('content', '');
          }
        } else {
          delete attr['data-form-element-session'];
          delete attr['data-form-element-collection'];
          delete attr['data-form-parent-collection'];
          delete attr['data-form-element-collection-id'];
          delete attr['data-select-get-text-from'];
          selectFieldDiv.style.display = 'none';
          selectParentCollectionDiv.style.display = 'none';
          selectParentCollectionFieldDiv.style.display = 'none';
          component.addAttributes(attr);
          component.set('content', componentContent);
        }
      },
      onUpdate({ elInput, component }) {
        const selectFieldDiv = elInput.querySelector('#select-field-div');
        const selectField = elInput.querySelector('.selectField');
        const selectParentCollectionDiv = elInput.querySelector('#select-parent-collection-div');
        const selectParentCollection = elInput.querySelector('.selectParentCollection');
        const selectParentCollectionFieldDiv = elInput.querySelector(
          '#select-parent-collection-field-div',
        );
        const selectParentCollectionField = elInput.querySelector('.selectParentCollectionField');

        const attr = component.getAttributes();
        //Removes empty attribute key
        delete attr[''];
        const sessionFieldValue = attr['data-form-element-session'] || '';
        const collectionFieldValue = attr['data-form-element-collection'] || '';
        const collectionFieldValueId = attr['data-form-element-collection-id'] || '';
        const parentCollection = attr['data-form-parent-collection'] || '';
        const selectGetTextFromValue = attr['data-select-get-text-from'] || '';
        const formCollection = attr['data-form-collection'] || '';
        const formType = attr['data-form-type'];
        const addRemoveCollectionFrom = attr['collectionFrom'];
        const selectGetTextFromDiv = elInput.querySelector('#select-getTextFrom-div');
        const selectGetTextFrom = elInput.querySelector('.select-getTextFrom');

        console.log(
          '====>> onUpdate #3 sessionFieldValue:::',
          sessionFieldValue,
          'collectionFieldValue:::',
          collectionFieldValue,
          'selectGetTextFromValue :::',
          selectGetTextFromValue,
          'parentCollection :::',
          parentCollection,
          'collectionFieldValueId:::',
          collectionFieldValueId,
          'formType :::',
          formType,
          'formCollection :::',
          formCollection,
          'addRemoveCollectionFrom :::',
          addRemoveCollectionFrom,
        );

        let addRemoveCollection =
          formType === 'addToCollection' ? 'Add Collection' : 'Remove Collection';
        let addToRemoveFromCollection =
          formType === 'addToCollection' ? 'Add To Collection' : 'Remove From Collection';

        let collectionFromTrait = component.getTrait('collectionFrom');
        if (typeof collectionFromTrait !== 'undefined') {
          collectionFromTrait.set({
            label: addRemoveCollection,
          });
        }

        let addToRemoveFromTrait = component.getTrait('data-element-field-name');
        if (typeof addToRemoveFromTrait !== 'undefined') {
          addToRemoveFromTrait.set({
            label: addToRemoveFromCollection,
          });
        }

        if (selectGetTextFromValue) {
          selectGetTextFrom.value = selectGetTextFromValue;
          selectGetTextFromDiv.style.display = 'block';

          if (selectGetTextFromValue === 'session' && sessionFieldValue) {
            let optionHtml = `<option value="" selected>None</option>`;
            selectFieldDiv.style.display = 'block';
            optionHtml += `${session.options
              .map((opt) => `<option value="${opt.id}">${opt.name}</option>`)
              .join('')}`;
            selectField.innerHTML = optionHtml;
            selectField.value = sessionFieldValue;
          } else if (
            selectGetTextFromValue === 'collection' &&
            collectionFieldValue &&
            collectionFieldValueId
          ) {
            selectFieldDiv.style.display = 'block';
            selectField.innerHTML = collection
              ? getFieldOptionsForAddToRemoveFromSelect(collection.options)
              : '';
            selectField.value = collectionFieldValueId + '#' + collectionFieldValue;
          } else if (
            selectGetTextFromValue === 'collections' &&
            collectionFieldValue &&
            collectionFieldValueId &&
            parentCollection
          ) {
            selectParentCollectionFieldDiv.style.display = 'block';
            let selectedParentCollection = collections.filter(
              (e) => e.collectionName === parentCollection,
            );

            let optionHtml = selectedParentCollection[0].fields
              ? addRemoveCollectionFrom === 'getFromPageContext'
                ? getFieldOptionsForCollectionSelect(
                    selectedParentCollection[0].fields,
                    formCollection,
                  )
                : getFieldOptionsForCollectionSelect(selectedParentCollection[0].fields)
              : '';

            selectParentCollectionField.innerHTML = optionHtml;
            let formElementFieldRefCollection = selectedParentCollection[0].fields.filter(
              (field) => field.fieldName === collectionFieldValue,
            );

            selectParentCollectionDiv.style.display = 'block';
            selectParentCollection.innerHTML = collections
              ? getCollectionOptionsForSelect(collections)
              : '';
            selectParentCollection.value = parentCollection;

            if (addRemoveCollectionFrom === 'getFromPageContext') {
              selectParentCollectionField.value =
                collectionFieldValueId + '#' + collectionFieldValue + '#' + formCollection;
            } else {
              selectParentCollectionField.value =
                collectionFieldValueId +
                '#' +
                collectionFieldValue +
                '#' +
                formElementFieldRefCollection[0].refCollection.collectionName;
            }
          }
        } else {
          selectFieldDiv.style.display = 'none';
          selectParentCollectionDiv.style.display = 'none';
          selectParentCollectionFieldDiv.style.display = 'none';
        }
      },
    });
  }
}
